import { useEffect, useState } from 'react';

import { createHoverPrefetcher } from '@/features/metric-studio';
import type { HoverPrefetcher } from '@/features/metric-studio/prefetch';

/**
 * 導覽清單用的 hover／touch 預取器：跟著呼叫它的元件活，卸載時清掉計時器。
 * SideNav 與 BottomTabBar 各持有一個（見 SideNav.tsx 的 `MetricNavGroups`）。
 */
export function useNavPrefetcher(): HoverPrefetcher {
  const [instance] = useState(createHoverPrefetcher);
  useEffect(() => {
    return () => {
      instance.dispose();
    };
  }, [instance]);
  return instance;
}
